import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaCar, FaMotorcycle, FaHeartbeat, FaBuilding, FaPlane } from 'react-icons/fa';
import './Products.css';

const Products = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [hash]);

  const products = [
    {
      id: 'car',
      icon: <FaCar />,
      title: 'Car Insurance',
      description: 'Comprehensive coverage for your car with protection against accidents, theft, natural calamities, and third-party liabilities.',
      benefits: [
        'Coverage for own damage and third-party liability',
        'Cashless claim settlement at network garages',
        '24/7 roadside assistance',
        'No Claim Bonus (NCB) up to 50%',
        'Add-on covers available'
      ]
    },
    {
      id: 'bike',
      icon: <FaMotorcycle />,
      title: 'Bike Insurance',
      description: 'Protect your two-wheeler with comprehensive insurance that covers damages, theft, and third-party liabilities.',
      benefits: [
        'Complete protection for your bike',
        'Affordable premium rates',
        'Quick claim processing',
        'NCB benefits',
        'Personal accident cover'
      ]
    },
    {
      id: 'health',
      icon: <FaHeartbeat />,
      title: 'Health Insurance',
      description: 'Safeguard your health and finances with comprehensive health insurance plans covering hospitalization, treatments, and more.',
      benefits: [
        'Cashless hospitalization',
        'Pre and post hospitalization coverage',
        'Day care procedures covered',
        'Health check-up benefits',
        'Family floater options'
      ]
    },
    {
      id: 'commercial',
      icon: <FaBuilding />,
      title: 'Commercial Insurance',
      description: 'Protect your business assets, employees, and operations with tailored commercial insurance solutions.',
      benefits: [
        'Property and asset protection',
        'Liability coverage',
        'Business interruption cover',
        'Employee protection',
        'Customized plans'
      ]
    },
    {
      id: 'travel',
      icon: <FaPlane />,
      title: 'Travel Insurance',
      description: 'Travel with confidence knowing you are protected against medical emergencies, trip cancellations, and baggage loss.',
      benefits: [
        'Medical emergency coverage',
        'Trip cancellation protection',
        'Baggage loss coverage',
        'Travel delay benefits',
        'Worldwide coverage'
      ]
    }
  ];

  return (
    <div className="products-page">
      <div className="products-hero">
        <div className="products-banner">
          <div className="products-banner-left">
            <h1>Our Insurance Products</h1>
            <p>Comprehensive coverage for all your insurance needs</p>
          </div>

          <div className="products-banner-illustration">
  <img
    src="/products-icons.png"
    alt="insurance products icons"
    className="products-icon-image"
  />
</div>
        </div>
      </div>

      <section className="products-section">
        <div className="container">
          {products.map((product, index) => (
            <div key={product.id} id={product.id} className="product-item card">
              <div className="product-header">
                <div className="product-icon">{product.icon}</div>
                <h2 className="product-title">{product.title}</h2>
              </div>
              <p className="product-description">{product.description}</p>
              <div className="product-benefits">
                <h3>Key Benefits:</h3>
                <ul>
                  {product.benefits.map((benefit, idx) => (
                    <li key={idx}>{benefit}</li>
                  ))}
                </ul>
              </div>
              <Link to="/inquiry" className="btn btn-primary">
                Submit Inquiry
              </Link>
            </div>
          ))}
        </div>
      </section>

      <section className="products-cta">
        <div className="container">
          <h2>Need Help Choosing the Right Insurance?</h2>
          <p>Our experts are here to help you find the perfect coverage for your needs.</p>
          <Link to="/contact" className="btn btn-secondary">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Products;


